import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { useAuth } from '../Authentication/AuthenticationProvider';
import { GetCurrentBrand } from '../Configuration/ConfigurationManager';
import { GetBasket } from '../Order/Payment/Basket.js';
import { GenericErrorBox } from '../UI/ErrorBox/GenericErrorBox';
import { Loading } from './Loading';
import { GetADToken } from './TokenManager';

export function PrivateRoute({ children }) {
    const [basket, setBasket] = useState(null);
    const { environment } = useParams();
    const { fid } = useParams();
    const params = new URLSearchParams(window.location.search);
    const auth = useAuth();
    const location = useLocation();
    const navigate = useNavigate();
    const [guestUser, setGuestUser] = useState(location.state ? location.state.guestUser : "");
    const [guestSession, setGuestSession] = useState(location.state ? location.state.guestSession : "");
    const [errors, setErrors] = useState([]);
    const purchasingFor = params.get("purchasingFor");
    const adtoken=GetADToken();
    const {isLoading, userData} = auth;
    const anon = !!userData?.anon;  //anonymous user
    const hasGuestUser = !!guestUser

    const isValidHttpUrl = (string) => {
        let url;

        try {
            url = new URL(string);
        } catch (_) {
            return false;
        }

        return url.protocol === "http:" || url.protocol === "https:";
    }

    const GetBasketForGuestCheck = async(purchaseTarget) => {

        try {

            const basket = await GetBasket({ fid, loadfromserver: true, purchaseTarget });

            if(!basket || typeof basket !== "object"){
              console.log("Invalid basket returned");
              return;
            } 

            if (!basket.allowcustomercheckout && !adtoken || guestSession) {

                let url = '/guest/' + basket.id + window.location.search;
                navigate(url, { state: location.state, replace: true });
            }
            else {
                setBasket(basket);
            }
        }
        catch(error){
            let unexpected = [];
            unexpected.push("error.unexpected");
            setErrors(unexpected);
            console.error("Error in fetching basket data", error)

        }
        
    }

    const RedirectToMiddleware = async () => {
        try {
            const brand = await GetCurrentBrand(null);
    
            let environment = window.location.hostname;
            if (environment === 'localhost') {
                environment = 'ad-frontend.abasoft.co.uk';
            }
    
            let params = new URLSearchParams(window.location.search);
    
            const isLoggingOut = params.get('logout') === 'true';
            let loginURL = isLoggingOut
                ? `${brand.authmiddlewareurl}/${environment}/logout?ReturnUrl=`
                : `${brand.authmiddlewareurl}/${environment}/login?ReturnUrl=`;
    
            let ReturnUrl = window.location.protocol + "//" + window.location.host + window.location.pathname;
    
            if (window.location.search) {
                for (let [key, value] of params) {
                    if (isValidHttpUrl(value)) {
                        params.set(key, encodeURIComponent(value));
                    }
                }
                ReturnUrl += "?" + params.toString();
            }
    
            loginURL += encodeURIComponent(ReturnUrl);
    
            if (basket?.allowguestcheckout && window.location.pathname.startsWith('/payment')) {
                loginURL += "&PassThruUrl=";
                let PassThruUrl = window.location.protocol + "//" + window.location.host + window.location.pathname.replace('payment', 'guest');
                if (window.location.search) {
                    PassThruUrl += "?" + params.toString();
                }
                loginURL += encodeURIComponent(PassThruUrl);
            }
    
            window.location.href = loginURL;
    
        } catch (err) {
            let unexpected = [];
            unexpected.push("error.unexpected");
            setErrors(unexpected);
            console.error("Redirection to Middleware has failed:", err);
        }
    };
    

    useEffect(() => {

        if (!basket) {
            if (window.location.pathname.startsWith('/payment') && (!adtoken || guestSession)) {
                GetBasketForGuestCheck(purchasingFor || "unknown");
             
            }
        }

        if(!userData || userData?.anon){
            const token = GetADToken();
            if(!token){
                auth.ReloadUserData();  // reload user token data when no token
            }
        }

    }, [])

    useEffect(()=>{
        
        if((anon && !hasGuestUser) && basket){
            RedirectToMiddleware();   // if no user then redirect to middleware
        }

    }, [anon, hasGuestUser, basket])


    const combinedErrors = [  ...(auth?.errors ?? []) , ...(errors ?? [])]

    if (combinedErrors?.length > 0) {

        const unexpectedError= ["error.unexpected"]; // showing an unexpected error message for all collective errors
        return   <div className="container-wrapper one-column">
                     <GenericErrorBox errors={unexpectedError} />
                 </div>;
    }

   if (anon || isLoading) {
        return <Loading loading={true} />;
    }

    return children;   // authorized so return child components
}

export default PrivateRoute;